import { Store, Module, ActionContext } from "vuex";
import AppConsts from "@/lib/appconst";
import ListModule from "./list-module";
import ListState from "./list-state";
import Product from "../entities/product";
import Ref from "../entities/ref";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import Country from "../entities/country";
import ProductForView from "../entities/productForView";
import ProductForSelect from "../entities/products/product-for-select";
import ProductHistory from "../entities/product-history";
interface ProductState extends ListState<Product> {
  editProduct: Product;
  editSave: Array<any>;
  permissions: Array<string>;
  storageTypes: Array<Ref>;
  inventModels: Array<Ref>;
  types: Array<Ref>;
  productTypes: Array<Ref>;
  countries: Array<Country>;
  viewProduct: Product;
  productHistory: ProductHistory;
}
class ProductModule extends ListModule<ProductState, any, Product> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Product>(),
    loading: false,
    editSave: new Array<any>(),
    editProduct: new Product(),
    permissions: new Array<string>(),
    storageTypes: new Array<Ref>(),
    inventModels: new Array<Ref>(),
    types: new Array<Ref>(),
    productTypes: new Array<Ref>(),
    countries: new Array<Country>(),
    viewProduct: new Product(),
    productHistory: new ProductHistory(),
  };
  actions = {
    async getAll(context: ActionContext<ProductState, any>, payload: any) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<Product>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
      return page.items;
    },
    async GetAllProduct(context: ActionContext<ProductState, any>, payload: any) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.post("/api/services/app/Product/GetAllProduct", payload.data);
      context.state.loading = false;
      const page = result as PageResult<Product>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
      return page.items;
    },
    async create(context: ActionContext<ProductState, any>, payload: any) {
      await Ajax.post("/api/services/app/Product/Create", payload.data);
    },
    async update(context: ActionContext<ProductState, any>, payload: any) {
      await Ajax.put("/api/services/app/Product/Update", payload.data);
    },
    async updateImage(context: ActionContext<ProductState, any>, payload: any) {
      await Ajax.put("/api/services/app/Product/UpdateImage", payload.data);
    },

    async delete(context: ActionContext<ProductState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.put(
        "/api/services/app/Product/DeleteProduct", payload.data
      );
      context.state.loading = false;
    },
    async get(context: ActionContext<ProductState, any>, payload: any) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/GetProductById", {
        params: payload.data,
      });
      return result as ProductForView;
    },
    async GetProductWarrantyDurationById(context: ActionContext<ProductState, any>, payload: any) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/GetProductWarrantyDurationById", {
        params: payload.data,
      });
      return result;
    },
    async getAllPermissions(context: ActionContext<ProductState, any>) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/getAllPermissions");
      context.state.permissions = result.items;
    },
    async getListStorageTypesForSelect(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      var params = {
        tableName: AppConsts.tableRef.tableProduct.name,
        columnName: AppConsts.tableRef.tableProduct.column.storageType,
        prefix: AppConsts.tableRef.tableProduct.prefix.storageType,
      };
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/GetRefsForSelect", {
        params: params,
      });
      context.state.storageTypes = result.items as Ref[];
    },
    async getListInventModelsForSelect(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      var params = {
        tableName: AppConsts.tableRef.tableProduct.name,
        columnName: AppConsts.tableRef.tableProduct.column.inventModel,
      };
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/GetRefsForSelect", {
        params: params,
      });
      context.state.inventModels = result.items as Ref[];
    },
    async getListTypesForSelect(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      var params = {
        tableName: AppConsts.tableRef.tableProduct.name,
        columnName: AppConsts.tableRef.tableProduct.column.type,
        prefix: AppConsts.tableRef.tableProduct.prefix.type,
      };
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/GetRefsForSelect", {
        params: params,
      });
      context.state.types = result.items as Ref[];
    },
    async getListProductTypesForSelect(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      var params = {
        tableName: AppConsts.tableRef.tableProduct.name,
        columnName: AppConsts.tableRef.tableProduct.column.productType,
        prefix: AppConsts.tableRef.tableProduct.prefix.productType,
      };
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/GetRefsForSelect", {
        params: params,
      });
      context.state.productTypes = result.items as Ref[];
    },
    async getPoProductTypes(context: ActionContext<ProductState, any>) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/poProductTypes");
      return result.items as Ref[];
    },
    async getListCountriesForSelect(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/GetCountriesForSelect");
      context.state.countries = result.items as Country[];
    },
    async uploadProductImage(
      context: ActionContext<ProductState, any>,
      data: any
    ) {
      const {
        data: { result },
      } = await Ajax.post("/api/services/app/Product/UploadProductImage", data);
      return result;
    },
    async checkClientProductInvBalBySku(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/Product/CheckClientProductInvBalBySku",
        { params: payload.data }
      );
      return result;
    },
    async checkClientProductInvBal(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/CheckClientProductInvBal", {
        params: payload.data,
      });
      return result;
    },
    async checkClientProductBySku(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/CheckClientProductBySku", {
        params: payload.data,
      });
      return result;
    },
    async searchProductForSelect(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/SearchProductForSelect", {
        params: payload.data,
      });
      return result.items as ProductForSelect[];
    },
    async autogenSKU(context: ActionContext<ProductState, any>, payload: any) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/AutogenSKU");
      return result;
    },
    async createMaster(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      await Ajax.post("/api/services/app/Product/CreateMaster", payload.data);
    },
    async updateMaster(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      await Ajax.put("/api/services/app/Product/UpdateMaster", payload.data);
    },
    async getDimensions(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/dimensions", {
        params: payload.data,
      });
      return result;
    },
    async getProductHistory(
      context: ActionContext<ProductState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Product/GetEntitysChange", {
        params: payload.data,
      });

      context.commit("setProductHistory", result);
    },
  };
  mutations = {
    setCurrentPage(state: ProductState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: ProductState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: ProductState, product: Product) {
      state.editProduct = product;
    },
    editSave(state: ProductState, dataChildProducts: Array<any>) {      
      state.editSave = dataChildProducts;
    },
    view(state: ProductState, product: Product) {
      state.viewProduct = product;
    },
    setProductHistory(state: ProductState, productHistory: ProductHistory) {
      state.productHistory = productHistory;
    },
  };
}
const productModule = new ProductModule();
export default productModule;
